import React, { CSSProperties } from "react";

import { Container } from "./styles";

interface Props {
  styles?: CSSProperties;
  children: React.ReactNode;
}

export const PanelLayout: React.FC<Props> = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};
